import { type z } from 'zod';

import { SharedLib } from '@shared';

/**
 * Состояние перечня проектов, как его несёт адресная строка (`rules/lists-and-filters.mdc` §1).
 *
 * Расширение общей схемы списочного экрана, а не своя: `page`, `perPage` и `q` обязаны означать
 * одно и то же в реестре документов и здесь, иначе «страница 2» — это разное в двух разделах одного
 * приложения (`rules/frontend-fsd.mdc` п. 13). Отбор проектов беднее реестра документов намеренно:
 * у проекта нет ни состояния разбора, ни периметра, ни обращения — есть наименование и время
 * сборки, и фильтр, которого нет на сервере, был бы контролом, ничего не меняющим.
 *
 * **Порядка в адресе нет, и это не упущение.** Контракт перечня проектов принимает `q`, `page` и
 * `perPage`; порядок он задаёт сам — свежие сверху, — и никакого способа его сменить не публикует.
 * Параметр `sort` в адресной строке был бы контролом, который ничего не меняет, а уходя на сервер,
 * он ещё и получал `422` на каждый запрос перечня: экран не грузился вовсе. Появится порядок в
 * контракте — вернётся и параметр, вместе с `listSearchSchemaWithSort`.
 */

/** Размеры страницы, которые предлагает экран, — те же, что в реестре документов. */
export const DRAFT_PER_PAGE_OPTIONS = [25, 50, 100] as const;

export const draftRegistrySearchSchema = SharedLib.listSearchSchema;

export type DraftRegistrySearch = z.infer<typeof draftRegistrySearchSchema>;
